import React from 'react';
import {Divider, Grid} from '@mui/material';
import './component.css';
import AgyleLoadingSpinner from '../../../other/agyleLoadingSpinner';
import {useTranslation} from 'react-i18next';
import {getConfig} from '../../../../util/configUtil';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import Formatter from '../../../../util/formatter';

const GpDemographic = ({gp, surgery, loadingData}) => {
    const {t} = useTranslation();

    // Configs
    const defaultDateFormat = getConfig('defaultDateFormat');

    const renderAddress = (address, index, type) => {
        let text = '';
        text = address.postalCode ? `${address.postalCode}\n` : '-';
        const addressLines = address.addressLines || address.lines;
        if (addressLines && addressLines.length > 0) {
            addressLines.forEach(element => {
                text += element ? `${element}\n` : '';
            });
        }
        return (
            <Grid key={index} item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {`${type} ${t('Address')} ${index + 1}`}
                </Typography>

                <Typography variant="body1" className="body">
                    {t('Type')}: {address.typeName || '-'}
                </Typography>

                <Typography variant="body1" className="body" style={{whiteSpace: 'pre-wrap', fontSize: 11}}>
                    {text}
                </Typography>
            </Grid>
        );
    };

    const renderPhoneNumbers = (phone) => {
        if (!phone?.isActive) return null;

        return (
            <Grid key={Math.random()} item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {`${t('Telephone')}${phone?.type ? ` (${phone.type})` : '-'}`}
                </Typography>

                <Typography variant="body1" className="body" style={{whiteSpace: 'pre-wrap'}}>
                    {phone?.phone || '-'}
                </Typography>
            </Grid>
        );
    };

    const renderGpDetails = () => {
        return (
            <>
                <Grid item xs={12} className="container-grid">
                    <Typography variant="body1" fontWeight={800}>
                        {t('GP Details')}
                    </Typography>

                    <Divider style={{marginBottom: 10}}/>
                </Grid>

                {gp &&
                    <>
                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('GP Name')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {Formatter.getGPFullName(gp)}
                            </Typography>
                        </Grid>

                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('Joined')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {gp?.joinParent ? moment(gp.joinParent).format(defaultDateFormat) : '-/-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('Left')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {gp?.leftParent ? moment(gp.leftParent).format(defaultDateFormat) : '-/-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('GP Code')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {gp?.gpCode || '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('GP Phone Contact')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {gp?.phoneNumber || '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('GP Email Address')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {gp?.emailAddress || '-'}
                            </Typography>
                        </Grid>

                        {renderAddress(gp.address, 0, 'GP')}
                    </>
                }
                {!gp &&
                    <Typography variant="body1" className="title" style={{marginLeft: 10}}>
                        {t('No GP details found')}
                    </Typography>
                }
            </>
        );
    };

    const renderSurgeryDetails = () => {
        return (
            <>
                <Grid item xs={12} className="container-grid">
                    <Typography variant="body1" fontWeight={800}>
                        {t('Surgery Details')}
                    </Typography>

                    <Divider style={{marginBottom: 10}}/>
                </Grid>

                {surgery &&
                    <>
                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('Practice Name')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {surgery?.practiceName || '-'}
                            </Typography>
                        </Grid>

                        <Grid item xs={3} className="container-grid">
                            <Typography variant="body1" className="title">
                                {t('Practice Code')}
                            </Typography>

                            <Typography variant="body1" className="body">
                                {surgery?.practiceCode || '-'}
                            </Typography>
                        </Grid>

                        {surgery?.addresses?.map((address, index) => (
                            renderAddress(address, index, 'Surgery')
                        ))}

                        {surgery?.phoneNumbers?.map((phone) => (
                            renderPhoneNumbers(phone)
                        ))}
                    </>
                }
                {!surgery &&
                    <Typography variant="body1" className="title" style={{marginLeft: 10}}>
                        {t('No Surgery details found')}
                    </Typography>
                }
            </>
        );
    };

    return (
        <Grid container spacing={1} columns={9} className="container" alignContent="flex-start">
            {loadingData &&
                <Grid item xs={12} className="container-grid">
                    <AgyleLoadingSpinner/>
                </Grid>
            }
            {!loadingData &&
                <>
                    {renderGpDetails()}
                    {renderSurgeryDetails()}
                </>
            }

        </Grid>
    );
};

export default React.memo(GpDemographic);